export default {
  list: { lazy: () => import('./WalletProductVariant'), component: 'WalletProductVariantList' },
  edit: { lazy: () => import('./WalletProductVariant'), component: 'WalletProductVariantEdit' },
  create: { lazy: () => import('./WalletProductVariant'), component: 'WalletProductVariantCreate' },
}
